/* istanbul ignore file */
import { mainTheme } from '@cambridgeassessment/cambridge-ui';
import { CssBaseline, ThemeProvider } from '@material-ui/core';
import { createTheme } from '@material-ui/core/styles';
import React from 'react';
import { render } from 'react-dom';
import { BrowserRouter } from 'react-router-dom';
import { initializeGA } from 'src/utils/googleAnalytics';
import favicon from './assets/img/favicon.png';
import fonts from './assets/styles/fonts';
import App from './components/App';
import envVariables from './env';
import { UserProvider } from './hooks/useAuth';
import { FeatureFlagProvider } from './hooks/useFeatureFlags';
import { NotificationsProvider } from './hooks/useNotifications';
import { SchemaProvider } from './hooks/useSchema';
import Compose from './utils/Compose';
import { initializeHotJar } from './utils/hotJar';

initializeGA();
initializeHotJar();

const rootEl = document.getElementById('root');

const muiTheme = createTheme({
  ...mainTheme,
  //NOSONAR TODO: remove when line-heights are fixed CDS-567
  typography: {
    ...mainTheme.typography,
    h1: {
      ...mainTheme.typography.h1,
      lineHeight: '50px',
    },
    h2: {
      ...mainTheme.typography.h2,
      lineHeight: '42px',
    },
    h3: {
      ...mainTheme.typography.h3,
      lineHeight: '32px',
    },
    h4: {
      ...mainTheme.typography.h4,
      lineHeight: '26px',
    },
    h5: {
      ...mainTheme.typography.h5,
      lineHeight: '22px',
    },
  },
  breakpoints: {
    values: {
      xs: 0,
      sm: 600,
      md: 1024,
      lg: 1600,
      xl: 1920,
    },
  },
  overrides: {
    ...mainTheme.overrides,
    MuiTextField: {
      ...mainTheme.overrides.MuiTextField,
      root: {
        ...mainTheme.overrides.MuiTextField?.root,
        marginBottom: 8,
      },
    },
    MuiLink: {
      ...mainTheme.overrides.MuiLink,
      root: {
        ...mainTheme.overrides.MuiLink?.root,
        fontSize: 16,
        lineHeight: '20px',
      },
    },
    MuiCssBaseline: {
      '@global': {
        '@font-face': [...fonts],
        html: {
          WebkitFontSmoothing: 'auto',
        },
      },
    },
  },
});

const providers: React.FC[] = [
  BrowserRouter,
  UserProvider,
  FeatureFlagProvider,
  NotificationsProvider,
  SchemaProvider,
  ({ children }) => {
    return (
      <ThemeProvider theme={muiTheme}>
        <CssBaseline />
        {children}
      </ThemeProvider>
    );
  },
];

const apiKey =
  envVariables.NODE_ENV === 'development'
    ? '3_g0VqF7c6mmN3KYJCiEMdJOLF_lKb3h0qiXK6Uf1P17tLrbXpfY-P7ayDwBPIdFNR'
    : envVariables.API_KEY;

const gigyaScript = document.createElement('script');
gigyaScript.setAttribute(
  'src',
  `https://${envVariables.CDN_DATA_CENTER}/js/gigya.js?apiKey=${apiKey}`
);
document.head.appendChild(gigyaScript);

const fav = document.getElementById('favicon') as HTMLLinkElement;
fav.href = favicon;

render(
  <Compose components={providers}>
    <App />
  </Compose>,
  rootEl
);
